// extracted by mini-css-extract-plugin
module.exports = {"root":"PageHeading_root__2dP2o","heading":"PageHeading_heading__2gsrU","button":"PageHeading_button__1ukeD"};